// extracted by mini-css-extract-plugin
export var container = "separator-module--container--DNQV0";
export var stroke = "separator-module--stroke--aEhAc";